module.exports = __webpack_public_path__ + "static/media/check_box.7eb0370c.svg";